import { Injectable } from '@angular/core';
import { createEffect, Actions, ofType } from '@ngrx/effects';

import { map, tap, catchError, switchMap } from 'rxjs/operators';
import { of } from 'rxjs';
import { NzNotificationService } from 'ng-zorro-antd/notification';
import { APIService } from '../../services/api/api.service';

import * as NoteSelectors from './note.selectors';
import * as NoteActions from './note.actions';
import { AppState } from '../app.states';
import { Store } from '@ngrx/store';
const REQ_SIZE_LIMIT = 10;

@Injectable()
export class NoteEffects {
  constructor(
    private actions$: Actions,
    private apiService: APIService,
    private notification: NzNotificationService,
    private store: Store<AppState>
  ) {}

  loadNotes$ = createEffect(() =>
    this.actions$.pipe(
      ofType(NoteActions.loadNotes),
      switchMap(action =>
        this.apiService
          .getNotes({ ...action.filters })
          .pipe(
            map(notes => NoteActions.loadNotesSuccess({ notes })),
            catchError(error => {
              console.error('Error', error);
              this.notification.error('Error', 'Failed to load notes.');
              return of(NoteActions.loadNotesFailure({ error }));
            })
          )
      )
    )
  );

  loadAppointmentNotes$ = createEffect(() =>
    this.actions$.pipe(
      ofType(NoteActions.loadAppointmentNotes),
      switchMap(action =>
        this.apiService
          .getNotes({ appointment: action.appointmentId })
          .pipe(
            map(notes => NoteActions.loadAppointmentNotesSuccess({ notes })),
            catchError(error => {
              console.error('Error', error);
              this.notification.error('Error', 'Failed to load appointment notes.');
              return of(NoteActions.loadAppointmentNotesFailure({ error }));
            })
          )
      )
    )
  );

  upsertNote$ = createEffect(() =>
    this.actions$.pipe(
      ofType(NoteActions.upsertNote),
      switchMap(({ note }) => {
        const req$ = note._id
          ? this.apiService.updateNote(note)
          : this.apiService.saveNote(note);
        return req$.pipe(
          map(note => NoteActions.upsertNoteSuccess({ note })),
          catchError(error => of(NoteActions.upsertNoteFailure({ error })))
        );
      })
    )
  );

  upsertNoteSuccess$ = createEffect(
    () =>
      this.actions$.pipe(
        ofType(NoteActions.upsertNoteSuccess),
        tap(() => this.notification.success('Note Saved', ''))
      ),
    {
      dispatch: false
    }
  );

  upsertNoteFailure$ = createEffect(
    () =>
      this.actions$.pipe(
        ofType(NoteActions.upsertNoteFailure),
        tap(error => {
          console.error('Error', error);
          this.notification.error('Error', 'Failed to save note.');
        })
      ),
    {
      dispatch: false
    }
  );
}
